import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "href", "onClick", "tokens"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef } from 'react';
import ButtonText from '@segment/matcha/components/ButtonText';
import { withDesignTokens } from '@segment/matcha/useDesignTokens';
import * as views from './SupportLink.views';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var SupportLinkBase = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      href = _ref.href,
      onClick = _ref.onClick,
      tokens = _ref.tokens,
      rest = _objectWithoutProperties(_ref, _excluded);

  return _jsx(views.Item, _objectSpread(_objectSpread({
    ref: ref
  }, rest), {}, {
    children: _jsx(ButtonText, {
      size: "small",
      variant: "mono",
      href: href,
      onClick: onClick,
      color: tokens.color,
      children: children
    })
  }));
});
var SupportLink = withDesignTokens(SupportLinkBase, function (_props, theme) {
  return {
    color: theme.palette.twilio.gray[100]
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[900]
    };
  },
  twilioLight: function twilioLight() {
    return {};
  },
  twilioDark: function twilioDark() {
    return {};
  }
});
export default SupportLink;